import React, { useState } from "react";
import styles from "./ImagePreview.module.scss";

const ImagePreview = ({ images, isOpen, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleNext = () => {
    if (currentImageIndex < images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay} onClick={onClose}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button className={styles.closeButton} onClick={onClose}>
              &times;
            </button>
            {images?.length > 1 && (
              <div className={styles.imageCounter}>
                {currentImageIndex + 1} / {images.length}
              </div>
            )}
            <div className={styles.imageContainer}>
              <img
                loading="lazy"
                src={images[currentImageIndex]}
                alt="Preview"
              />
            </div>
            {images?.length > 1 && (
              <div className={styles.navigation}>
                <button onClick={handlePrev} disabled={currentImageIndex === 0}>
                  &larr; Prev
                </button>
                <button
                  onClick={handleNext}
                  disabled={currentImageIndex === images.length - 1}
                >
                  Next &rarr;
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePreview;
